<div #accelaControlDiv [id]="this.getDivElementId()" class="textinput accelaControl" [formGroup]="this.controlRef.parent">
  <label [for]="this.getLabelElementId()" [id]="this.getLabelElementId()" [attr.data-required]="this.controlData.required">{{this.label}}</label>
  <p-inputMask [formControlName]="this.controlData.name" [name]="this.controlData.name" [id]="'mask' + this.controlData.name" [mask]="this.controlData.mask" [ariaLabel]="this.getLabelElementId()" 
               [inputId]="this.controlData.name" type="phone" [placeholder]="this.controlData.placeholder" 
               tooltipEvent="hover|focus" [accelaTooltip]="this.controlData.tooltip" [tooltipZIndex]="2000" [appendTo]="accelaControlDiv"
                [escape]="false" [ariaLabel]="this.label" [attr.aria-required]="this.controlData.required" tooltipPosition="bottom"
               [required]="this.controlData.required" [readonly]="this.controlData.readOnly || readonlyMode" (blur)="emitBlurEvent($event)">
  </p-inputMask>
</div>
<div *ngIf="!this.adminMode" class="validationFeedback">
  <small *ngIf="this.controlRef?.errors?.required && (this.controlRef?.touched || this.controlRef?.dirty)"
         class="ng-invalid p-invalid">
    {{this.getRequiredFieldValidationMsg()}}
  </small>
</div>

